'use strict';

let pageViewUrl = $('meta[name=page-view]').attr("content");

if (pageViewUrl) {
    $.ajax({
        url: pageViewUrl,
        method: 'post'
    });
}

$('.u-populate-view-count').each(function () {
    let target = $(this);
    let url = target.data('url');

    $.get(url, function (data) {
        if (parseInt(data, 10) > 0) {
            target.html(data);
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/components/page-view.js